module.exports = __webpack_public_path__ + "619bdf92953fb0a0211a93c27d53c791.png";